import { clientOnly } from "@solidjs/start";

const ArenaSignupSection = clientOnly(async () =>
  import("@/components/arena-page/arena-signup-section").then((mod) => ({
    default: mod.ArenaSignupSection,
  })),
);

export default function ArenaPage() {
  return (
    <main class="relative min-h-full w-full">
      <ArenaSignupSection />
    </main>
  );
}
